
import React from 'react';
import { Button } from '../../../components/base/Button';

export const AboutSection: React.FC = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="about" className="py-20 lg:py-32 bg-[#0A1628] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          {/* Section Label */}
          <div className="flex items-center justify-center mb-8">
            <div className="w-4 h-4 bg-[#00D4FF] transform rotate-45 mr-3"></div>
            <span className="text-[#00D4FF] font-medium text-sm uppercase tracking-wider">
              ABOUT BALESTRA
            </span>
          </div>

          {/* Main Title */}
          <h2 className="text-4xl lg:text-5xl font-bold mb-12 leading-tight">
            Protecting Digital Privacy Since Day One
          </h2>

          {/* Content Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 mb-16">
            {/* Main Description */}
            <div className="lg:col-span-2 text-left">
              <p className="text-lg text-gray-300 leading-relaxed mb-6">
                BALESTRA DOO CACAK was founded with a simple mission: to make the internet 
                a safer place for everyone. In an era where digital privacy is constantly 
                under threat, we believe that security should be accessible, reliable, and 
                uncompromising.
              </p>
              <p className="text-lg text-gray-300 leading-relaxed mb-6">
                Our team of cybersecurity experts has developed cutting-edge VPN technology 
                that doesn't just protect your data—it ensures your complete digital freedom. 
                From our headquarters in Serbia, we serve users worldwide with enterprise-grade 
                security solutions that you can trust.
              </p>
              <p className="text-lg text-gray-300 leading-relaxed">
                Every day, we work tirelessly to stay ahead of emerging threats and maintain 
                the highest standards of privacy protection. Your security is our commitment, 
                and your trust is our responsibility.
              </p>
            </div>

            {/* Company Details */}
            <div className="space-y-6">
              <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 text-left border border-white/10">
                <h3 className="text-xl font-bold mb-4 text-[#00D4FF]">Company Overview</h3>
                <div className="space-y-3 text-gray-300">
                  <div>
                    <span className="text-white font-medium">Company:</span> BALESTRA DOO CACAK
                  </div>
                  <div>
                    <span className="text-white font-medium">Location:</span> Serbia
                  </div>
                  <div>
                    <span className="text-white font-medium">Focus:</span> VPN Security Solutions
                  </div>
                  <div>
                    <span className="text-white font-medium">Mission:</span> Digital Privacy Protection
                  </div>
                </div>
              </div>

              {/* Security Stats */}
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 text-center border border-white/10">
                  <div className="text-2xl font-bold text-[#00D4FF] mb-1">24/7</div>
                  <div className="text-xs text-gray-400 uppercase tracking-wider">Monitoring</div>
                </div>
                <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 text-center border border-white/10">
                  <div className="text-2xl font-bold text-[#00D4FF] mb-1">100%</div>
                  <div className="text-xs text-gray-400 uppercase tracking-wider">No Logs</div>
                </div>
              </div>
            </div>
          </div>

          {/* Technology Showcase */}
          <div className="bg-gradient-to-r from-[#1E3A5F] to-[#1A4D7C] rounded-3xl p-8 lg:p-12 mb-16">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
              <div className="text-left">
                <h3 className="text-3xl font-bold mb-4">Our Technology Advantage</h3>
                <p className="text-gray-300 leading-relaxed mb-6">
                  We leverage the latest advancements in cryptography and network security 
                  to deliver unparalleled protection. Our proprietary security protocols 
                  are constantly updated to defend against emerging threats.
                </p>
                <div className="grid grid-cols-2 gap-4">
                  <div className="text-center p-4 bg-black/20 rounded-xl">
                    <i className="ri-shield-check-line text-3xl text-[#00D4FF] mb-2"></i>
                    <div className="text-sm font-medium">Advanced Encryption</div>
                  </div>
                  <div className="text-center p-4 bg-black/20 rounded-xl">
                    <i className="ri-global-line text-3xl text-[#00D4FF] mb-2"></i>
                    <div className="text-sm font-medium">Global Network</div>
                  </div>
                </div>
              </div>
              
              <div className="relative">
                <img 
                  src="https://public.readdy.ai/ai/img_res/ce55406366893c5aade3b2ae91db3808.jpg"
                  alt="BALESTRA Technology Center"
                  className="w-full h-64 object-cover object-center rounded-2xl"
                />
                <div className="absolute inset-0 bg-gradient-to-tr from-[#00D4FF]/20 to-transparent rounded-2xl"></div>
              </div>
            </div>
          </div>

          {/* CTA Button */}
          <div>
            <Button 
              variant="primary" 
              size="lg"
              onClick={() => scrollToSection('contact')}
            >
              Learn More About Our Technology
              <i className="ri-arrow-right-line"></i>
            </Button>
          </div>

          {/* Brand Statement */}
          <div className="mt-20 pt-16 border-t border-gray-700">
            <div className="text-[#C8B8A0] font-bold text-6xl lg:text-8xl tracking-tight">
              BALESTRA
            </div>
            <div className="text-gray-400 text-lg mt-4">
              Your Digital Security Partner
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
